<footer>
    <div class="footer-container">
        <span v-if="type !== 'classifica'"
              v-html="t('footer.text')"
              class="conditions tac"></span>
    </div>
</footer>